module.exports = __webpack_public_path__ + "jtails-build/img/checkout-time-out.aa649bf6.svg";